import { lazyGetAttachmentSuggestionsAction } from 'owa-attachment-suggestions';
import { ComposeViewState } from 'owa-mail-compose-store';

export default async function loadAttachmentSuggestions(
    composeViewState: ComposeViewState
): Promise<void> {
    const getAttachmentSuggestionsAction = await lazyGetAttachmentSuggestionsAction.import();

    // Since we await, must check again that composeViewState still exists.
    if (composeViewState) {
        getAttachmentSuggestionsAction(
            composeViewState.referenceItemId && composeViewState.referenceItemId.Id
        );
    }
}
